var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGovernmentWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.65,
    height: 68.902,
    viewBox: "0 0 71.65 68.902",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "government",
    d: "M44.825,60.644a5.588,5.588,0,1,1,5.588-5.588A5.588,5.588,0,0,1,44.825,60.644Zm0,1.45a10.374,10.374,0,0,0-10.311,9.565.718.718,0,0,0,.719.775H54.416a.718.718,0,0,0,.719-.775,10.374,10.374,0,0,0-10.311-9.565ZM14.5,78.593l-.806,1.936H75.955l-.806-1.936a.713.713,0,0,0-.669-.446H15.17a.713.713,0,0,0-.67.446ZM9.721,72.434H28.9a.718.718,0,0,0,.719-.775A10.34,10.34,0,0,0,9,71.659.718.718,0,0,0,9.721,72.434Zm60.615-10.34a10.374,10.374,0,0,0-10.311,9.565.718.718,0,0,0,.719.775H79.928a.718.718,0,0,0,.719-.775,10.374,10.374,0,0,0-10.311-9.565Zm9.024,21.258a.715.715,0,0,0-.691-.5H10.98a.715.715,0,0,0-.691.5L9.182,86.807a.435.435,0,0,0,.414.568H80.053a.435.435,0,0,0,.414-.568ZM70.337,60.644a5.588,5.588,0,1,0-5.588-5.588A5.588,5.588,0,0,0,70.337,60.644ZM74.428,44.77l.892-2.046H14.33l.892,2.046a.712.712,0,0,0,.665.435H73.763A.712.712,0,0,0,74.428,44.77Zm-60.7,10.286a5.588,5.588,0,1,0,5.588-5.588A5.588,5.588,0,0,0,13.725,55.056ZM10.45,40.4,9,37.207,44.825,18.473,80.65,37.206,79.2,40.4H10.45ZM39.624,30.26a5.2,5.2,0,1,0,5.2-5.2A5.2,5.2,0,0,0,39.624,30.26Z",
    transform: "translate(-9 -18.473)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernmentWhiteIcon);
export default __webpack_public_path__ + "static/media/government_white_icon.2c9c2d25ae7a8861d8b87bc4c6e09dae.svg";
export { ForwardRef as ReactComponent };